/** @prettier */

/* eslint-disable import/prefer-default-export */
import { camelizeKeys } from 'humps';
import { normalize } from 'normalizr';

import { ALL_MARKET_TYPES } from '@xanadu/ui-shared/components/GlobalEventsPage/settings';
import { event } from '@xanadu/ui-shared/modules/schema';

const OPTIONS = {
  credentials: 'same-origin',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Id-Type': 'String',
  },
};

function constructEventUrl({ tags, product } = {}) {
  const parameters = {
    product,
    offset: 0,
    'per-page': 20,
    'price-mode': 'aggregated',
    'price-order': 'price desc',
    'market-states': 'open',
    'runner-states': 'open',
    'tag-url-names': tags,
    'market-types': ALL_MARKET_TYPES.join(','),
  };

  const querystring = Object.keys(parameters)
    .map((key) => `${key}=${encodeURIComponent(parameters[key])}`)
    .join('&');

  return `/edge/rest/events?${querystring}`;
}

export function fetchRelatedEvents({ competition, product }) {
  const url = constructEventUrl({ tags: competition, product });

  return (
    fetch(url, OPTIONS)
      .then((response) => response.json())
      .then(({ events = [] }) => normalize(camelizeKeys(events), [event]))
      // eslint-disable-next-line no-console
      .catch((e) => console.log(e) || {})
  );
}
